var _circle, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublicGoodsNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 475,
    height: 474,
    viewBox: "0 0 475 474",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 237.719,
    cy: 236.987,
    r: 230.938,
    fill: "white",
    stroke: "black",
    strokeWidth: 12
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 129.729,
    y: 129.495,
    width: 139.322,
    height: 139.322,
    fill: "black",
    stroke: "black",
    strokeWidth: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 206.385,
    y: 205.156,
    width: 139.322,
    height: 139.322,
    fill: "black",
    stroke: "black",
    strokeWidth: 12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 206.146,
    y: 205.156,
    width: 62.9055,
    height: 62.9055,
    fill: "white",
    stroke: "black",
    strokeWidth: 12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicGoodsNetwork);
export default __webpack_public_path__ + "static/media/PublicGoodsNetwork.929173b23ee1939263ac8197ac52fbbd.svg";
export { ForwardRef as ReactComponent };